module.exports = __webpack_public_path__ + "img/feature_buy_bonus_ko.95108105.png";